import { Button, HTMLChakraProps, ThemingProps } from '@chakra-ui/react';
import { FC, forwardRef } from 'react';

interface IPopoverButtonProps extends HTMLChakraProps<'button'>, ThemingProps {}

export const PopoverButton: FC<IPopoverButtonProps> = forwardRef<HTMLButtonElement, IPopoverButtonProps>(
  ({ children, ...rest }, ref) => (
    <Button ref={ref} isActive={rest['aria-expanded'] as boolean} {...rest}>
      {children}
    </Button>
  )
);
